"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: var(--font-size-default);\n  color: var(--color-secondary);\n  font-weight: bold;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 3rem;\n  width: 30rem;\n  background-color: var(--color-secondary-light-1);\n  box-shadow: var(--box-shadow-default);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 30rem;\n  padding: 3rem;\n  text-align: center;\n  color: var(--color-primary-dark-3);\n  font-size: var(--font-size-default);\n  font-weight: bold;\n  background-color: var(--color-primary-light-1);\n\n  box-shadow: var(--box-shadow-default);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledUrlViewDiv = styled_components_1.default.div(_templateObject());
exports.StyledEmptyActionDiv = styled_components_1.default.div(_templateObject2());
exports.StyledEmptyActionTextP = styled_components_1.default.p(_templateObject3());